export default "__VITE_PUBLIC_ASSET__17770a32__"